// Vendors
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
import { useLayoutEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Event Handlers
import { TokenHandlers } from '../handlers/token.handlers';
import { LogHandlers } from 'handlers/log.handlers';

const useTokenHook = (): void => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const { showBoundary: setError } = useErrorBoundary();

  const { informationFlags, setInformationFlags } = useAppInformationContextConsumerHook();

  const { handleSendCustomActionEvent } = LogHandlers(),
    { handleFetchCustomerAuthorizationData } = TokenHandlers({
      handleSendCustomActionEvent,
      informationFlags,
      setInformationFlags,
      setError,
      urlSearchParams,
    });

  useLayoutEffect(() => {
    handleFetchCustomerAuthorizationData();
  }, [informationFlags]);
};

export { useTokenHook };
